import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {AppBar, Badge, BottomNavigation, BottomNavigationAction} from "@mui/material";
import {
    CreditCard as CardIcon,
    MoreHoriz as MoreIcon,
    Notifications as NotificationsIcon,
    Receipt as ChargesIcon
} from "@mui/icons-material";
import MoreMenu from "../moreMenu/moreMenu";
import {arrays} from "@atttomyx/shared-utils";
import {router} from "@atttomyx/react-utils";
import {PAGE_CARD, PAGE_CHARGES, PAGE_NOTIFICATIONS, PAGES_MAIN, PAGES_MORE} from "../../constants";
import "./footer.css";

const PAGE_MORE = "more";
const PAGE_OTHER = "other";

const Footer = (props) => {
    const {history, numNotifications, numFailedCharges, hasCard,
        onLogout, bootstrap, onSwitchAccounts, snackbar} = props;
    const [showMore, setShowMore] = useState(false);

    const path = router.getCurrentPage(history);
    let page = PAGE_OTHER;

    if (arrays.contains(PAGES_MAIN, path)) {
        page = path;

    } else if (arrays.contains(PAGES_MORE, path)) {
        page = PAGE_MORE;
    }

    return <div className="footer">
        <AppBar className="bottom-nav" position="fixed" color="default">
            <BottomNavigation
                value={page}
                showLabels={true}
            >
                <BottomNavigationAction
                    value={PAGE_CHARGES}
                    label="Charges"
                    icon={<Badge color="error"
                                 badgeContent={numFailedCharges}
                                 invisible={numFailedCharges === 0}>
                        <ChargesIcon/>
                    </Badge>}
                    onClick={() => router.redirectTo(history, PAGE_CHARGES)}
                />
                <BottomNavigationAction
                    value={PAGE_CARD}
                    label="Card"
                    icon={<Badge color="error"
                                 badgeContent="!"
                                 invisible={hasCard}>
                        <CardIcon/>
                    </Badge>}
                    onClick={() => router.redirectTo(history, PAGE_CARD)}
                />
                <BottomNavigationAction
                    value={PAGE_NOTIFICATIONS}
                    label="Notifications"
                    icon={
                        <Badge
                            color="error"
                            badgeContent={numNotifications}
                            invisible={numNotifications === 0}>
                            <NotificationsIcon/>
                        </Badge>}
                    onClick={() => router.redirectTo(history, PAGE_NOTIFICATIONS)}
                />
                <BottomNavigationAction value={PAGE_MORE}
                                        label="More"
                                        icon={<MoreIcon/>}
                                        component="div"
                                        onClick={() => setShowMore(true)}
                />
            </BottomNavigation>
        </AppBar>
        {showMore ?
            <MoreMenu
                onCancel={() => setShowMore(false)}
                onLogout={onLogout}
                bootstrap={bootstrap}
                onSwitchAccounts={onSwitchAccounts}
                snackbar={snackbar}
            /> : null}
    </div>
}

export default withRouter(Footer);
